import { Check, Close, SwapHoriz } from '@mui/icons-material';
import { JudgmentProgressBar } from 'features/fact-grabbing/JudgmentProgressBar';
import { JudgmentCounts } from 'features/fact-grabbing/useReferencesByClaim';
import styled from 'styled-components';
import useTr from 'utils/hooks/useTr';

type Props = {
  judgmentCounts: JudgmentCounts;
};

export const JudgmentProgressBars = ({ judgmentCounts }: Props) => {
  const translate = useTr();

  return (
    <Root>
      <JudgmentProgressBar
        icon={<CheckIcon />}
        label={translate(
          'aiWriter.inspirations.factGrabbing.claim.details.judgment_progress_bar.pro.label'
        )}
        count={judgmentCounts.pro}
        total={judgmentCounts.all}
        color="success"
      />

      <JudgmentProgressBar
        icon={<SwapIcon />}
        label={translate(
          'aiWriter.inspirations.factGrabbing.claim.details.judgment_progress_bar.neutral.label'
        )}
        count={judgmentCounts.neutral}
        total={judgmentCounts.all}
        color="warning"
      />

      <JudgmentProgressBar
        icon={<CloseIcon />}
        label={translate(
          'aiWriter.inspirations.factGrabbing.claim.details.judgment_progress_bar.con.label'
        )}
        count={judgmentCounts.con}
        total={judgmentCounts.all}
        color="error"
      />
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.two};
  margin-bottom: ${({ theme }) => theme.spacings.three};
`;

const CheckIcon = styled(Check)`
  color: ${({ theme }) => theme.colors.secondaryColorMain};
`;

const CloseIcon = styled(Close)`
  color: ${({ theme }) => theme.colors.accentRedDark};
`;

const SwapIcon = styled(SwapHoriz)`
  color: ${({ theme }) => theme.colors.accentYellowDark};
`;
